import Link from "next/link";

const FilterNav = props => {
	const { nav, navTitle, navAll, allRoute = '', navColor = 'black', active = '' } = props;

	return (
		<div id="filterNav" className={`filterNavHolder nav-${navColor}`}>
			<div className="navBuilder">
				{navTitle &&
					<div className="navTitle">
						{navTitle}
					</div>}
				{navAll &&
					<div className={`navBuilderItem ${active === 'all' || active === '' ? 'active' : ''}`}>
						<Link passHref legacyBehavior href={`${allRoute}#filterNav`}>
							<a title={navAll}>{navAll}</a>
						</Link>
					</div>}
				{nav && nav.map(n => {
					const isActive = active === n.slug;

					return (
						<div className={`navBuilderItem ${isActive ? 'active' : ''}`} key={n.id}>
							<Link passHref legacyBehavior href={`${allRoute}?category=${n.slug}#filterNav`}>
								<a title={n.title}>{n.title}</a>
							</Link>
						</div>
					)
				})}
			</div>
		</div>
	);
};

export default FilterNav;